import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=571c41ce&scoped=true"
import script from "./StoresList.vue?vue&type=script&lang=ts"
export * from "./StoresList.vue?vue&type=script&lang=ts"
import style0 from "./StoresList.vue?vue&type=style&index=0&id=571c41ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c41ce",
  null
  
)

export default component.exports